import { useEffect, useState } from 'react';

export const useMobile = (boundary = 1200) => {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= boundary);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= boundary);
    };
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return { isMobile, setIsMobile };
};
